import { Injectable } from '@angular/core';
import JSZip from 'jszip';

@Injectable({
  providedIn: 'root'
})
export class ZipService {

  constructor() { }

  async extractFiles(file: File): Promise<File[]> {
    const zip = new JSZip();
    const zipContent = await zip.loadAsync(file);
    const extractedFiles: File[] = [];

    for (const filename of Object.keys(zipContent.files)) {
      const fileData = zipContent.files[filename];
      // Ignore directories and macOS hidden files
      if (!fileData.dir && !filename.startsWith('__MACOSX/') && !filename.split('/').pop()?.startsWith('.')) {
        const blob = await fileData.async('blob');
        const extractedFile = new File([blob], filename, { type: blob.type || 'application/octet-stream' });
        extractedFiles.push(extractedFile);
      }
    }
    return extractedFiles;
  }
}
